export enum ProjectRole {
  ProjectManager = 1,
  ProjectMember = 2,
}
